import { render, staticRenderFns } from "./MovableImageObject.vue?vue&type=template&id=ddd60032&scoped=true&"
import script from "./MovableImageObject.vue?vue&type=script&lang=ts&"
export * from "./MovableImageObject.vue?vue&type=script&lang=ts&"
import style0 from "./MovableImageObject.vue?vue&type=style&index=0&id=ddd60032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd60032",
  null
  
)

export default component.exports